import { useEffect, useMemo, useState } from "react";
import { fetchCorporateDaily } from "../api/client.js";
import { useTranslation } from "react-i18next";

export default function PriceTable() {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCorporateDaily()
      .then((res) => setRows(res?.items || []))
      .catch((err) => {
        console.error(err);
        setError(t("admin.prices.errors.load"));
      });
  }, [t]);

  const sortedRows = useMemo(() => {
    return [...rows].sort((a, b) => {
      const provider = (a.provider || "").localeCompare(b.provider || "");
      if (provider !== 0) return provider;
      return (a.location || "").localeCompare(b.location || "");
    });
  }, [rows]);

  return (
    <div className="max-w-5xl mx-auto">
      <h1 className="text-xl font-bold mb-4">{t("admin.prices.title")}</h1>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      {sortedRows.length === 0 ? (
        <div className="bg-white shadow rounded p-6 text-center text-gray-500">
          {t("admin.prices.none")}
        </div>
      ) : (
        <div className="bg-white shadow rounded p-4 overflow-x-auto">
          <h2 className="font-semibold mb-3">{t("admin.prices.daily")}</h2>
          <div className="max-h-[32rem] overflow-y-auto">
            <table className="w-full border-collapse border border-gray-300 text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border p-2 text-left">{t("admin.prices.table.provider")}</th>
                  <th className="border p-2 text-left">{t("admin.prices.table.location")}</th>
                  <th className="border p-2 text-left">{t("admin.prices.table.product")}</th>
                  <th className="border p-2 text-left">{t("admin.prices.table.category")}</th>
                  <th className="border p-2 text-right">{t("admin.prices.table.unitPrice")}</th>
                  <th className="border p-2 text-left">{t("admin.prices.table.date")}</th>
                </tr>
              </thead>
              <tbody>
                {sortedRows.map((row, idx) => (
                  <tr key={`${row.provider}-${row.location}-${row.product_name}-${idx}`}>
                    <td className="border p-2">{row.provider}</td>
                    <td className="border p-2">
                      {row.location || row.postal_code || row.municipality || "—"}
                    </td>
                    <td className="border p-2">
                      {row.product_name || row.fuelTypeLabel || "—"}
                    </td>
                    <td className="border p-2">
                      {row.categoryLabel || row.fuelTypeLabel || "—"}
                    </td>
                    <td className="border p-2 text-right">
                      {row.unit_price != null ? row.unit_price.toFixed(4) : "—"}
                    </td>
                    <td className="border p-2">
                      {row.report_date
                        ? new Date(row.report_date).toLocaleDateString("fi-FI")
                        : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
